import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const BodyPartSelection = ({
  question,
  frontBodyParts,
  onClickFrontBodyParts,
  backBodyParts,
  onClickBackBodyParts,
}) => {
  return (
    <div className="cxa-grid__wrapper apl-body__selector">
      <div className="cxa-grid__item cxa-grid__item--six">
        <div>
          <p>
            <FormattedMessage id={question.questionText} defaultMessage={question.questionText} />
          </p>
          <ul>
            <li>
              <FormattedMessage {...messages.painDullAcheNumbnessDescription} />
            </li>
            <li>
              <FormattedMessage {...messages.sensationDescription} />
            </li>
            <li>
              <FormattedMessage {...messages.tinglingDescription} />
            </li>
            <li>
              <FormattedMessage {...messages.tirednessDescription} />
            </li>
            <li>
              <FormattedMessage {...messages.swellingDesctiption} />
            </li>
            <li>
              <FormattedMessage {...messages.muscleDescription} />
            </li>
            <li>
              <FormattedMessage {...messages.lossDescription} />
            </li>
          </ul>
        </div>
      </div>
      <div className="cxa-grid__item cxa-grid__item--three cxa-body-parts-container">
        <h4>
          <FormattedMessage {...messages.frontDescription} />
        </h4>
        <svg width="129.65" height="293.8" viewBox="0 0 129.65 293.8">
          <path
            id="front-body"
            className="apl-body__frame"
            d="M60.51,217.4a28.33,28.33,0,0,0,.19,7.42c4,12.37-.38,25.88-1,31.2s1,16.36,1.9,18.07,0,9.13,0,9.13l-.57,7.42a4.07,4.07,0,0,1-2.47,2.67c-9.13,1.71-12-1.71-12-1.71-1.34-1.45,0-3.89,1.58-6.19.33-.68.66-1.35.86-1.67.3-.5,1.45-2.25,2.28-3.89.13-1.6-1.12-2.26-.34-4.43,1-2.67-1-9.89-1-9.89-8.56-24.54-7.23-30.63-7.42-37.1s1.52-6.66.19-11.23-.76-8.18-.19-11.61-4.38-25.88-4.38-25.88c-7.12-23.37-4.92-38.09-.76-52.89a90.57,90.57,0,0,0,3.14-30.56c0,.18-.87.43-.95.73a59.17,59.17,0,0,0-1.19,7,23.74,23.74,0,0,1-2.11,12.09c-2.44,5.85-10,23.23-12.91,27.69,0,0-1,2.16-1.54,3.53l-.46,3.4a15.6,15.6,0,0,0,.21,3.22c1.94,5,.58,15.28.64,16.31s-.25,2.41-1.52,2.28-1-5-1.52-5.14c-.3-.07-.56.59-.73,1.15-.08.33-2.37,7.53-2.37,7.53a1.86,1.86,0,0,1-1.71,1.71c-1.21.06-1.52-1.27-1.52-1.27-.32,1.14-1,1.08-1.84,1s-1-1.65-1-1.65c-.38,1-2,.63-2,.63-2.41-.06-1.59-12.94-.76-14.9a15,15,0,0,0,.82-4.17c-1.71.87-3.49,3.43-4.24,4-1,.7-2.67,1.2-3.43.38a1.9,1.9,0,0,1,.51-3c1.27-.89,2.22-3.8,2.22-3.8a12.84,12.84,0,0,1,6.21-8.12,11.32,11.32,0,0,0,3.91-4.44c1.84-5.22,3.1-17.35,4.78-27.59,2-12,8.56-14.4,6.91-20.55s-.57-14.46.13-17.13-.25-4.44-.25-14.4,8.37-13.89,12.3-14.59a84.86,84.86,0,0,0,9.07-2.35C49.5,44.69,54,42.07,54.84,41a4,4,0,0,0,.32-1.19l-.08-5.52s-1.79-1.35-2-7.15c0,0-1.15.64-1.47-.58a11.32,11.32,0,0,0-1-3.16c-.49-.65-1.14-2.44-.24-2.76a4,4,0,0,0,.76-.51,24,24,0,0,1-.61-8.51C51.19,7.83,52.62,3,58.8,1.07a11,11,0,0,1,6-1,11,11,0,0,1,6,1C77,3,78.45,7.83,79.12,11.63a24,24,0,0,1-.61,8.51,4,4,0,0,0,.77.51c.89.32.24,2.11-.25,2.76a11.24,11.24,0,0,0-1,3.16c-.33,1.22-1.48.58-1.48.58-.24,5.8-2,7.15-2,7.15l-.08,5.52A3.92,3.92,0,0,0,74.81,41c.82,1.07,5.34,3.69,8.53,4.79a84.82,84.82,0,0,0,9.07,2.35c3.93.7,12.3,4.63,12.3,14.59s-1,11.73-.25,14.4,1.77,11,.13,17.13,4.95,8.56,6.91,20.55c1.68,10.24,2.94,22.38,4.78,27.59a11.32,11.32,0,0,0,3.91,4.44,12.85,12.85,0,0,1,6.22,8.12s1,2.91,2.22,3.8a1.9,1.9,0,0,1,.51,3c-.76.83-2.47.32-3.42-.38-.75-.55-2.53-3.11-4.24-4a15,15,0,0,0,.82,4.17c.83,2,1.65,14.84-.76,14.9,0,0-1.65.32-2-.63,0,0-.06,1.52-1,1.65s-1.52.19-1.84-1c0,0-.32,1.33-1.52,1.27a1.86,1.86,0,0,1-1.71-1.71l-2.18-6.8c-.36-1.3-.63-2-.92-1.89-.51.13-.25,5-1.52,5.14s-1.58-1.14-1.52-2.28-1.3-11.27.56-15.78a17.67,17.67,0,0,0,.29-3.76l-.46-3.4c-.51-1.37-1.54-3.53-1.54-3.53-2.92-4.46-10.47-21.84-12.91-27.69s-2.27-9.18-2.11-11.69A52.21,52.21,0,0,0,90,97c-.07-.3-.9-.55-.95-.73a90.46,90.46,0,0,0,3.14,30.56c4.16,14.8,6.36,29.53-.76,52.89,0,0-4.95,22.45-4.38,25.88s1.14,7-.19,11.61.38,4.76.19,11.23,1.14,12.56-7.42,37.1c0,0-1.9,7.23-1,9.89.77,2.17-.47,2.82-.34,4.43.83,1.64,2,3.39,2.28,3.89.19.32.53,1,.86,1.67,1.57,2.3,2.92,4.74,1.58,6.19,0,0-2.85,3.42-12,1.71a4.07,4.07,0,0,1-2.47-2.67L68,283.23s-1-7.42,0-9.13,2.47-12.75,1.9-18.07-4.95-18.84-1-31.2a28.33,28.33,0,0,0,.19-7.42l-4.31-43.8Z"
            transform="translate(0 0)"
          />
          <path
            id="part2"
            className={
              frontBodyParts.includes("part2") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M84,68.32c0,7.36-8.5,8-19,8s-19-.64-19-8S54.5,55,65,55s19,6,19,13.32"
            transform="translate(0 0)"
          />
          <path
            id="part0"
            className={
              frontBodyParts.includes("part0") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M65.14,45.84c-3.91,0-7.14.41-7.14-4.65s3.33-2.6,7.24-2.6,6.93-2.46,6.93,2.6S69.05,45.84,65.14,45.84Z"
            transform="translate(0 0)"
          />
          <path
            id="part1b"
            className={
              frontBodyParts.includes("part1b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M100.6,56c3.28,4.3,2.73,10.23-1.23,13.26s-4.47-3.36-7.75-7.66-8.09-4.87-4.13-7.9,9.83-2,13.11,2.3"
            transform="translate(0 0)"
          />
          <path
            id="part3b"
            className={
              frontBodyParts.includes("part3b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M103,86.67c0,6.78-2.87,10-6.47,10S90,93.45,90,86.67,93.06,77,96.66,77,103,79.89,103,86.67"
            transform="translate(0 0)"
          />
          <path
            id="part13b"
            className={
              frontBodyParts.includes("part13b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M84,211.07c0,4.26-2.87,6.3-6.47,6.3s-6.56-2-6.56-6.3S74.06,205,77.66,205,84,206.81,84,211.07"
            transform="translate(0 0)"
          />
          <path
            id="part15b"
            className={
              frontBodyParts.includes("part15b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M76.84,273.93c-.31,2.49-1.74,3.52-3.34,3.32s-2.76-1.55-2.46-4,1.8-3.38,3.4-3.18,2.7,1.41,2.39,3.9"
            transform="translate(0 0)"
          />
          <path
            id="part6b"
            className={
              frontBodyParts.includes("part6b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M109.23,114.72c1.92,6.5,3.39,20.17-.06,21.19s-10.51-11-12.44-17.49.19-10.14,3.65-11.16,6.93,1,8.85,7.46"
            transform="translate(0 0)"
          />
          <path
            id="part5b"
            className={
              frontBodyParts.includes("part5b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M103,100c.27,1.53-1.16,3.08-4.6,3.68s-5.13-.44-5.4-2,1-3,4.43-3.57S102.76,98.51,103,100Z"
            transform="translate(0 0)"
          />
          <path
            id="part8b"
            className={
              frontBodyParts.includes("part8b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M110.45,140.33c2-.67,3.25-.27,3.55.64s-.26,2.66-2.29,3.33a2.73,2.73,0,0,1-3.63-1.42c-.3-.9.34-1.89,2.38-2.56"
            transform="translate(0 0)"
          />
          <path
            id="part11b"
            className={
              frontBodyParts.includes("part11b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M109.07,163.17s-.51-3.17,1.27-3.17,6.85,2.66,8.62,1.52,2.54,1.52,2.28,3c-.17,1,.51,8.88-3.68,9.13s-4.31-6.22-5.2-7.36-3.3-.51-3.3-3.17"
            transform="translate(0 0)"
          />
          <path
            id="part10b"
            className={
              frontBodyParts.includes("part10b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M112.14,148.07c1.47.41,3.3,4.57,4.95,6s3.42,2.79,2.92,4.95-9.26.76-9.39-2c0,0-2.13-9.89,1.52-8.88"
            transform="translate(0 0)"
          />
          <path
            id="part9b"
            className={
              frontBodyParts.includes("part9b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M118.34,147.5s3.78,2.42,5.33,5.7,2.22,4.85,1.13,4.9-4.31-3.23-6-5.17c-2.36-2.73-4.7-7.47-.47-5.43"
            transform="translate(0 0)"
          />
          <path
            id="part12b"
            className={
              frontBodyParts.includes("part12b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M70.39,190s-6.22-29,1.39-34.25,18.52-7.74,19,1.27S86.25,195,81.17,198.32s-9.51-1.27-10.78-8.37"
            transform="translate(0 0)"
          />
          <path
            id="part14b"
            className={
              frontBodyParts.includes("part14b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M73.52,254.58c1.42,4.41,5.33,6.09,6.66-.19s9.7-31.2-1.52-31.39c0,0-6.66-.38-7.42,9.51a57.66,57.66,0,0,0,2.28,22.07"
            transform="translate(0 0)"
          />
          <path
            id="part16b"
            className={
              frontBodyParts.includes("part16b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M70.05,286.35s-.51-2.79,1.65-3,4.44-1,6.09,1.52,3.8,4.69,2.92,5.83-4.31,1.9-6.47,1.65-3.81,0-4.19-6"
            transform="translate(0 0)"
          />
          <path
            id="part1a"
            className={
              frontBodyParts.includes("part1a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M30.14,56c-3.28,4.3-2.73,10.23,1.23,13.26s4.47-3.36,7.75-7.66,8.09-4.87,4.13-7.9-9.83-2-13.11,2.3"
            transform="translate(0 0)"
          />
          <path
            id="part3a"
            className={
              frontBodyParts.includes("part3a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M27,86.67c0,6.78,2.87,10,6.47,10S40,93.45,40,86.67,37,77,33.37,77,27,79.89,27,86.67"
            transform="translate(0 0)"
          />
          <path
            id="part13a"
            className={
              frontBodyParts.includes("part13a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M46,211.07c0,4.26,2.87,6.3,6.47,6.3s6.56-2,6.56-6.3S56,205,52.37,205,46,206.81,46,211.07"
            transform="translate(0 0)"
          />
          <path
            id="part15a"
            className={
              frontBodyParts.includes("part15a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M54.05,273.93c.31,2.49,1.74,3.52,3.34,3.32s2.76-1.55,2.45-4-1.8-3.38-3.4-3.18-2.7,1.41-2.39,3.9"
            transform="translate(0 0)"
          />
          <path
            id="part6a"
            className={
              frontBodyParts.includes("part6a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M21.08,135.91c3.45,1,10.51-11,12.43-17.49s-.19-10.14-3.64-11.16-6.93,1-8.85,7.46S17.63,134.89,21.08,135.91Z"
            transform="translate(0 0)"
          />
          <path
            id="part5a"
            className={
              frontBodyParts.includes("part5a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M32.6,98.19c-3.44-.6-5.3.33-5.56,1.86s1.15,3.08,4.59,3.68,5.13-.44,5.4-2-1-3-4.43-3.57"
            transform="translate(0 0)"
          />
          <path
            id="part8a"
            className={
              frontBodyParts.includes("part8a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M19.62,140.33c-2-.67-3.25-.27-3.55.64s.26,2.66,2.29,3.33A2.74,2.74,0,0,0,22,142.89c.3-.9-.34-1.89-2.38-2.56"
            transform="translate(0 0)"
          />
          <path
            id="part11a"
            className={
              frontBodyParts.includes("part11a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M21.22,163.17S21.73,160,20,160s-6.85,2.66-8.62,1.52S8.79,163,9,164.57c.16,1-.51,8.88,3.68,9.13s4.31-6.22,5.2-7.36,3.3-.51,3.3-3.17"
            transform="translate(0 0)"
          />
          <path
            id="part10a"
            className={
              frontBodyParts.includes("part10a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M18,148.07c-1.47.41-3.3,4.57-4.95,6s-3.42,2.79-2.92,4.95,9.26.76,9.39-2c0,0,2.13-9.89-1.52-8.88"
            transform="translate(0 0)"
          />
          <path
            id="part9a"
            className={
              frontBodyParts.includes("part9a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M11,147.5s-3.79,2.42-5.33,5.7-2.22,4.85-1.13,4.9,4.3-3.23,6-5.17c2.36-2.73,4.7-7.47.47-5.43"
            transform="translate(0 0)"
          />
          <path
            id="part12a"
            className={
              frontBodyParts.includes("part12a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M59.46,190s6.21-29-1.4-34.25S39.54,148,39,157,43.6,195,48.68,198.32s9.51-1.27,10.78-8.37"
            transform="translate(0 0)"
          />
          <path
            id="part14a"
            className={
              frontBodyParts.includes("part14a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M56.91,254.58c-1.42,4.41-5.33,6.09-6.66-.19s-9.7-31.2,1.52-31.39c0,0,6.66-.38,7.42,9.51a57.63,57.63,0,0,1-2.28,22.07"
            transform="translate(0 0)"
          />
          <path
            id="part16a"
            className={
              frontBodyParts.includes("part16a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M59.86,286.35s.51-2.79-1.65-3-4.44-1-6.09,1.52-3.8,4.69-2.92,5.83,4.31,1.9,6.47,1.65,3.81,0,4.19-6"
            transform="translate(0 0)"
          />
          <path
            id="part4"
            className={
              frontBodyParts.includes("part4") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickFrontBodyParts}
            d="M64.6,82C54.53,82.36,45,85.35,45,101.29c0,8.55,3.81,7,7.28,27.28,1.85,9.05,5.23,16.49,12.32,17.12,7.09-.64,10.47-8.07,12.32-17.12,3.47-20.24,7.28-18.73,7.28-27.28,0-15.94-9.54-18.93-19.6-19.29"
            transform="translate(0 0)"
          />
        </svg>
      </div>
      <div className="cxa-grid__item cxa-grid__item--three cxa-body-parts-container">
        <h4>
          <FormattedMessage {...messages.backDescription} />
        </h4>
        <svg width="129.35" height="293.8" viewBox="0 0 129.35 293.8">
          <path
            id="back-body"
            className="apl-body__frame"
            d="M128.33,158.38c-1.26-.89-2.22-3.79-2.22-3.79a12.8,12.8,0,0,0-6.2-8.1,11.3,11.3,0,0,1-3.9-4.43c-1.83-5.2-3.1-17.31-4.77-27.53-2-12-8.54-14.37-6.9-20.5s.57-14.43-.13-17.09.25-4.43.25-14.36S96.12,48.72,92.2,48a84.84,84.84,0,0,1-9.05-2.34c-3.18-1.09-7.7-3.7-8.51-4.78a3.8,3.8,0,0,1-.32-1.18l.08-5.51s1.79-1.35,2-7.13c0,0,1.15.64,1.47-.58a11.26,11.26,0,0,1,1-3.15c.49-.65,1.13-2.43.24-2.75a3.89,3.89,0,0,1-.76-.51,24,24,0,0,0,.61-8.49C78.27,7.81,76.85,3,70.68,1.07a11,11,0,0,0-6-1,11,11,0,0,0-6,1C52.5,3,51.08,7.81,50.41,11.61A23.88,23.88,0,0,0,51,20.1a3.94,3.94,0,0,1-.76.51c-.89.32-.24,2.11.24,2.75a11.17,11.17,0,0,1,1,3.15c.33,1.21,1.47.58,1.47.58.24,5.78,2,7.13,2,7.13L55,39.72a3.9,3.9,0,0,1-.32,1.18c-.82,1.07-5.33,3.68-8.51,4.78a84.82,84.82,0,0,1-9,2.34c-3.93.7-12.28,4.62-12.28,14.55s1,11.71.25,14.36S23.36,87.89,25,94s-4.94,8.54-6.9,20.5c-1.68,10.22-2.94,22.33-4.77,27.53a11.29,11.29,0,0,1-3.9,4.43,12.82,12.82,0,0,0-6.2,8.1s-.95,2.91-2.21,3.79a1.89,1.89,0,0,0-.5,3c.76.82,2.47.32,3.42-.38.75-.55,2.52-3.1,4.23-4a15,15,0,0,1-.82,4.16c-.82,2-1.64,14.81.76,14.87,0,0,1.64.32,2-.63,0,0,.07,1.52,1,1.65s1.52.19,1.83-.95c0,0,.32,1.33,1.52,1.26a1.85,1.85,0,0,0,1.71-1.71l2.18-6.78c0-.14.12-.4.19-.73.17-.56.44-1.22.73-1.15.51.13.25,5,1.52,5.13s1.58-1.14,1.52-2.28,1.3-11.24-.55-15.74c0-.22-.05-.41-.08-.53a15.52,15.52,0,0,1-.21-3.22l.46-3.39c.51-1.37,1.54-3.52,1.54-3.52,2.92-4.46,10.45-21.79,12.88-27.63s2.27-9.16,2.11-11.67c0-.12,0-.26,0-.39a59.89,59.89,0,0,1,1.18-6.95c.07-.3.9-.55.95-.73a90.3,90.3,0,0,1-3.13,30.49c-4.15,14.77-6.35,29.46.76,52.77,0,0,4.94,22.4,4.37,25.82s-1.14,7,.19,11.58-.38,4.75-.19,11.2-1.14,12.53,7.4,37c0,0,1.9,7.21,1,9.87-.77,2.16.46,2.82.34,4.42l0,0h-.93l-.8,3-.52.84c-.19.32-.52,1-.85,1.66-1.57,2.3-2.91,4.72-1.58,6.18a4.16,4.16,0,0,0,.86.68c.06,1.15.47,2.16,1.76,2.16H62s1.8-.38,1.71-2.85l-1.23-11.77h-.68c.15-2.18.19-4.78-.32-5.7-1-1.71-2.47-12.72-1.9-18s4.94-18.79.95-31.13a28.27,28.27,0,0,1-.19-7.4l4.3-43.7,4.3,43.7a28.19,28.19,0,0,1-.19,7.4c-4,12.34.38,25.82,1,31.13s-1,16.33-1.9,18c-.52.92-.47,3.52-.33,5.7h-.68L65.6,291c-.1,2.47,1.71,2.85,1.71,2.85H80.21c1.29,0,1.7-1,1.76-2.16a4.15,4.15,0,0,0,.85-.68c1.34-1.45,0-3.88-1.58-6.18-.33-.68-.66-1.34-.85-1.66l-.52-.84-.8-3h-.93l0,0c-.12-1.6,1.12-2.26.34-4.42-1-2.66.95-9.87.95-9.87,8.54-24.49,7.21-30.56,7.41-37s-1.52-6.65-.19-11.2.76-8.16.19-11.58,4.36-25.82,4.36-25.82c7.11-23.31,4.91-38,.76-52.77a90.38,90.38,0,0,1-3.13-30.49c.05.18.87.43.95.73a59.61,59.61,0,0,1,1.18,6.95c0,.14,0,.27,0,.39-.16,2.51-.32,5.83,2.11,11.67s10,23.17,12.88,27.63c0,0,1,2.16,1.54,3.52l.46,3.39a15.67,15.67,0,0,1-.21,3.22,4.47,4.47,0,0,0-.09.53c-1.85,4.5-.5,14.71-.56,15.74s.25,2.4,1.52,2.28,1-5,1.52-5.13c.3-.07.56.59.73,1.15.08.33.15.6.19.73l2.18,6.78a1.86,1.86,0,0,0,1.71,1.71c1.2.06,1.52-1.26,1.52-1.26.32,1.14,1,1.08,1.84.95s.95-1.65.95-1.65c.38.95,2,.63,2,.63,2.4-.06,1.58-12.91.76-14.87a15,15,0,0,1-.82-4.16c1.71.87,3.48,3.42,4.23,4,.95.7,2.66,1.2,3.42.38a1.89,1.89,0,0,0-.51-3"
            transform="translate(0 0)"
          />
          <path
            id="part2"
            className={
              backBodyParts.includes("part2") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M75.66,70a1.65,1.65,0,0,1,1-1.46,1,1,0,0,1,1.24.52c.71,1.7,3.13,6,6,6.72,2.53-.06,4-1.15,4-4.53C87.89,62.39,77.62,53,64.95,53S42,62.39,42,71.29c0,3.37,1.48,4.47,4,4.53,2.89-.69,5.3-5,6-6.72a1,1,0,0,1,1.24-.52,1.64,1.64,0,0,1,1,1.46,9.89,9.89,0,0,1-.84,4.68,57,57,0,0,1,11.56-1.47A57,57,0,0,1,76.5,74.71,9.9,9.9,0,0,1,75.66,70"
            transform="translate(0 0)"
          />
          <path
            id="part0"
            className={
              backBodyParts.includes("part0") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M65.88,48.77c3.43,2.2,12.44.76,12.67-.68.32-2-2.85-3.42-4.56-3.93a2.61,2.61,0,0,1-1.64-2c0-5-3.33-2.54-7.22-2.54S58.28,37.2,58.22,42a2.61,2.61,0,0,1-1.64,2c-1.71.51-4.87,2-4.56,3.92.23,1.42,9,2.84,12.52.77a1.29,1.29,0,0,1,1.33,0"
            transform="translate(0 0)"
          />
          <path
            id="part1a"
            className={
              backBodyParts.includes("part1a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M30.14,56c-3.27,4.29-2.72,10.21,1.23,13.23s4.46-3.35,7.74-7.64,8.07-4.86,4.12-7.88-9.8-2-13.08,2.29"
            transform="translate(0 0)"
          />
          <path
            id="part3a"
            className={
              backBodyParts.includes("part3a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M27,86.65c0,6.76,2.87,10,6.46,10S40,93.41,40,86.65,37,77,33.36,77,27,79.88,27,86.65"
            transform="translate(0 0)"
          />
          <path
            id="part13a"
            className={
              backBodyParts.includes("part13a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M46,211.06c0,4.25,2.86,6.28,6.45,6.28s6.55-2,6.55-6.28S55.95,205,52.36,205,46,206.81,46,211.06"
            transform="translate(0 0)"
          />
          <path
            id="part15a"
            className={
              backBodyParts.includes("part15a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M54.05,273.92c.31,2.48,1.73,3.51,3.33,3.31s2.76-1.55,2.45-4S58,269.83,56.44,270s-2.69,1.41-2.38,3.89"
            transform="translate(0 0)"
          />
          <path
            id="part6a"
            className={
              backBodyParts.includes("part6a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M21,114.7c-1.92,6.49-3.38,20.12.06,21.14s10.49-11,12.41-17.45-.19-10.12-3.64-11.14-6.91,1-8.83,7.45"
            transform="translate(0 0)"
          />
          <path
            id="part5a"
            className={
              backBodyParts.includes("part5a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M32.58,98.19c-3.43-.6-5.28.33-5.55,1.85s1.15,3.07,4.58,3.67,5.12-.44,5.39-2-1-3-4.42-3.56"
            transform="translate(0 0)"
          />
          <path
            id="part8a"
            className={
              backBodyParts.includes("part8a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M19.61,140.33c-2-.67-3.24-.27-3.54.64s.25,2.66,2.29,3.33A2.73,2.73,0,0,0,22,142.88c.3-.9-.34-1.88-2.37-2.55"
            transform="translate(0 0)"
          />
          <path
            id="part11a"
            className={
              backBodyParts.includes("part11a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M21.2,163.16S21.7,160,19.93,160s-6.83,2.66-8.61,1.52S8.79,163,9,164.56c.17,1-.51,8.86,3.67,9.11s4.3-6.2,5.19-7.34,3.29-.51,3.29-3.16"
            transform="translate(0 0)"
          />
          <path
            id="part10a"
            className={
              backBodyParts.includes("part10a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M17.93,148.07c-1.47.41-3.29,4.56-4.94,5.95s-3.42,2.79-2.91,4.94,9.24.76,9.36-2c0,0,2.12-9.87-1.52-8.86"
            transform="translate(0 0)"
          />
          <path
            id="part9a"
            className={
              backBodyParts.includes("part9a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M11,147.5s-3.78,2.42-5.32,5.68S3.45,158,4.54,158.07s4.3-3.22,6-5.16c2.36-2.72,4.69-7.46.47-5.41"
            transform="translate(0 0)"
          />
          <path
            id="part14a"
            className={
              backBodyParts.includes("part14a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M56.88,253.51c-1.42,4.4-5.31,6.08-6.65-.19S40.56,222.19,51.76,222c0,0,6.65-.38,7.4,9.49a57.53,57.53,0,0,1-2.28,22"
            transform="translate(0 0)"
          />
          <path
            id="part1b"
            className={
              backBodyParts.includes("part1b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M100.57,56c3.27,4.29,2.72,10.21-1.23,13.23s-4.46-3.35-7.74-7.64-8.07-4.86-4.12-7.88,9.81-2,13.08,2.29"
            transform="translate(0 0)"
          />
          <path
            id="part3b"
            className={
              backBodyParts.includes("part3b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M103,86.65c0,6.76-2.86,10-6.45,10S90,93.41,90,86.65,93.05,77,96.65,77,103,79.88,103,86.65"
            transform="translate(0 0)"
          />
          <path
            id="part13b"
            className={
              backBodyParts.includes("part13b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M84,211.06c0,4.25-2.86,6.28-6.45,6.28s-6.55-2-6.55-6.28S74,205,77.64,205,84,206.81,84,211.06"
            transform="translate(0 0)"
          />
          <path
            id="part15b"
            className={
              backBodyParts.includes("part15b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M76.82,273.92c-.31,2.48-1.73,3.51-3.33,3.31s-2.76-1.55-2.45-4,1.8-3.37,3.39-3.17,2.7,1.41,2.38,3.89"
            transform="translate(0 0)"
          />
          <path
            id="part6b"
            className={
              backBodyParts.includes("part6b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M109.19,114.7c1.92,6.49,3.38,20.12-.06,21.14s-10.49-11-12.41-17.45.19-10.12,3.64-11.14,6.91,1,8.83,7.45"
            transform="translate(0 0)"
          />
          <path
            id="part5b"
            className={
              backBodyParts.includes("part5b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M97.45,98.19c3.43-.6,5.29.33,5.55,1.85s-1.15,3.07-4.58,3.67-5.12-.44-5.39-2,1-3,4.42-3.56"
            transform="translate(0 0)"
          />
          <path
            id="part8b"
            className={
              backBodyParts.includes("part8b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M110.44,140.33c2-.67,3.24-.27,3.54.64s-.25,2.66-2.29,3.33a2.73,2.73,0,0,1-3.62-1.42c-.29-.9.34-1.88,2.37-2.55"
            transform="translate(0 0)"
          />
          <path
            id="part11b"
            className={
              backBodyParts.includes("part11b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M109.07,163.16s-.51-3.16,1.27-3.16,6.83,2.66,8.61,1.52,2.53,1.52,2.28,3c-.17,1,.51,8.86-3.67,9.11s-4.3-6.2-5.19-7.34-3.29-.51-3.29-3.16"
            transform="translate(0 0)"
          />
          <path
            id="part10b"
            className={
              backBodyParts.includes("part10b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M112.13,148.07c1.47.41,3.29,4.56,4.94,5.95s3.41,2.79,2.91,4.94-9.24.76-9.36-2c0,0-2.12-9.87,1.52-8.86"
            transform="translate(0 0)"
          />
          <path
            id="part9b"
            className={
              backBodyParts.includes("part9b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M118.34,147.5s3.77,2.42,5.32,5.68,2.21,4.84,1.13,4.89-4.3-3.22-6-5.16c-2.36-2.72-4.69-7.46-.47-5.41"
            transform="translate(0 0)"
          />
          <path
            id="part14b"
            className={
              backBodyParts.includes("part14b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M73.52,253.51c1.41,4.4,5.31,6.08,6.64-.19s9.68-31.13-1.52-31.32c0,0-6.64-.38-7.4,9.49a57.47,57.47,0,0,0,2.28,22"
            transform="translate(0 0)"
          />
          <path
            id="part4"
            className={
              backBodyParts.includes("part4") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M84,98.71C84,83.25,74.78,80.35,65,80c-9.76.35-19,3.25-19,18.71,0,5.61,1.69,3,3.82,9.2a29.48,29.48,0,0,0-.88,7.28c0,11.76,7.19,7.18,16.07,7.18s16.07,4.58,16.07-7.18a29.35,29.35,0,0,0-.88-7.28c2.14-6.23,3.82-3.58,3.82-9.2"
            transform="translate(0 0)"
          />
          <path
            id="part12b"
            className={
              backBodyParts.includes("part12b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M77.4,162.29c-7.76,1.6-9.28,7.83-9.4,12a128.38,128.38,0,0,0,2.16,15.33c1.27,7.08,5.7,11.64,10.76,8.35,2.45-1.59,4.89-9.18,6.71-17.62,0-.08,0-.14,0-.23.76-6.45,1.71-20.31-10.25-17.84"
            transform="translate(0 0)"
          />
          <path
            id="part12a"
            className={
              backBodyParts.includes("part12a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M52.65,162.29c7.75,1.6,9.28,7.83,9.4,12a128.86,128.86,0,0,1-2.16,15.33c-1.27,7.08-5.69,11.64-10.76,8.35-2.45-1.59-4.89-9.18-6.71-17.62,0-.08,0-.14,0-.23-.76-6.45-1.71-20.31,10.25-17.84"
            transform="translate(0 0)"
          />
          <path
            id="part7"
            className={
              backBodyParts.includes("part7") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M79.26,132.19c-5.9-.84-11.47,1.08-14.06,6.91-2.59-5.83-8.15-7.75-14.06-6.91-7.25,1-12.27,5.84-10.93,15.26s7.77,13.09,15,12.06c4.37-.62,8-2.83,10-6.54,1.93,3.71,5.6,5.91,10,6.54,7.25,1,13.68-2.65,15-12.06s-3.67-14.22-10.93-15.26"
            transform="translate(0 0)"
          />
          <path
            id="part16b"
            className={
              backBodyParts.includes("part16b") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M79.39,287.46c0,1.91.93,3.46-1.2,3.46H70.4c-2.13,0-1.2-1.55-1.2-3.46A3.67,3.67,0,0,1,73.05,284h2.49a3.67,3.67,0,0,1,3.85,3.46"
            transform="translate(0 0)"
          />
          <path
            id="part16a"
            className={
              backBodyParts.includes("part16a") ? "apl-body__part--selected" : "apl-body__part"
            }
            onClick={onClickBackBodyParts}
            d="M51.2,287.46c0,1.91-.92,3.46,1.2,3.46h7.79c2.13,0,1.2-1.55,1.2-3.46A3.67,3.67,0,0,0,57.54,284H55.05a3.68,3.68,0,0,0-3.85,3.46"
            transform="translate(0 0)"
          />
        </svg>
      </div>
    </div>
  );
};

BodyPartSelection.propTypes = {
  question: PropTypes.object,
  frontBodyParts: PropTypes.array,
  onClickFrontBodyParts: PropTypes.func,
  backBodyParts: PropTypes.array,
  onClickBackBodyParts: PropTypes.func,
};

export default BodyPartSelection;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/display-types/body-part-selection.jsx